import React from 'react';
import { useTimestamp } from '@front-activerse/common-components';
import {
  CookbookSearchConnectorApollo,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
} from '@front-activerse/common-components';
import CookbookSearchContainer from './CookbookSearchContainer';

export const CookbookSearchPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();
  return (
    <CookbookSearchConnectorApollo key={timestamp1}>
      {(search) => (
        <AddFavoriteCookbookMealConnectorApollo>
          {({ addCookbookMealToFavorite }) => (
            <RemoveFavoriteCookbookMealConnectorApollo>
              {({ removeCookbookMealFromFavorites }) => (
                <CookbookSearchContainer
                  key={timestamp1}
                  search={search}
                  addToFavorites={addCookbookMealToFavorite}
                  removeFromFavorites={removeCookbookMealFromFavorites}
                />
              )}
            </RemoveFavoriteCookbookMealConnectorApollo>
          )}
        </AddFavoriteCookbookMealConnectorApollo>
      )}
    </CookbookSearchConnectorApollo>
  );
};

export default CookbookSearchPage;
